((win)=>{
    var myLocalStorage;
    var mySessionStorage;
    function MemoryStorage() {
        this.data = {}
    }
    MemoryStorage.prototype.setItem = function (t, a) {
        var key = t;
        var value = a;
        // 存的时候都转换成string 保持跟浏览器一致
        this.data[key] = String(value);
    }
    MemoryStorage.prototype.getItem = function (t) {
        var key = t;
        // 没值返回null
        return this.data[key] || null;
    }
    MemoryStorage.prototype.removeItem = function (t) {
        delete this.data[t];
    }
    MemoryStorage.prototype.clear = function () {
        for(var key in this.data) {
            delete this.data[key]
        }
    }
    try {
        myLocalStorage = win.localStorage;
        mySessionStorage = win.sessionStorage;
    } catch (error) {
        myLocalStorage = new MemoryStorage();
        mySessionStorage = new MemoryStorage();
        Object.defineProperty(win, 'localStorage', {
            value: myLocalStorage,
            writable: true
        });
        Object.defineProperty(win, 'sessionStorage', {
            value: mySessionStorage,
            writable: true
        });
    }
})(window)